import { Component, Input, OnInit } from '@angular/core';
import * as chartData from '../../data/dashboard/default'

@Component({
  selector: 'app-performance-growth',
  templateUrl: './performance-growth.component.html',
  styleUrls: ['./performance-growth.component.scss']
})
export class PerformanceGrowthComponent implements OnInit {
  @Input() tooltip: any;
  @Input('data') data: any;
  public performanceGrowth: any;
  public show: boolean = false

  toggle() {
    this.show = !this.show
  }

  ngOnInit() {
    this.initGraph();
  }

  initGraph() {
    console.log(this.data);
    const labels = Object.keys(this.data);
    const values = Object.values(this.data);
    this.performanceGrowth = {
      series: [
        {
          name: "Growth",
          data: values
        },
      ],
      chart: {
        height: 150,
        type: "line",
        toolbar: {
          show: false,
        },
        dropShadow: {
          enabled: true,
          enabledOnSeries: undefined,
          top: 5,
          left: 0,
          blur: 4,
          color: "#7366ff",
          opacity: 0.22,
        },
      },
      grid: {
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      colors: ["#5527FF"],
      stroke: {
        width: 3,
        curve: "smooth",
      },
      xaxis: {
        type: "category",
        categories: labels,
        tickAmount: 10,
        labels: {
          style: {
            fontFamily: "Rubik, sans-serif",
          },
        },
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          gradientToColors: ["#5527FF"],
          shadeIntensity: 1,
          type: "horizontal",
          opacityFrom: 1,
          opacityTo: 1,
          colorStops: [
            {
              offset: 0,
              color: "#5527FF",
              opacity: 1,
            },
            {
              offset: 100,
              color: "#E069AE",
              opacity: 1,
            },
          ],
          // stops: [0, 100, 100, 100]
        },
      },
      yaxis: {
        min: -10,
        max: 40,
        labels: {
          show: false,
        },
      },
    };
  }
  
}
